import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/cadencias')({
  component: CadencesLayout,
})

function CadencesLayout() {
  return <Outlet />
}
